import React from "react";
import type { GatsbyBrowser } from "gatsby";
import { AuthProvider } from "./src/context/AuthContext";
import { CartProvider } from "./src/context/CartContext";
import { WishlistProvider } from "./src/context/WishlistContext";
import AuthModal from "./src/components/auth/AuthModal";
import "./src/styles/global.css";

export const wrapRootElement: GatsbyBrowser["wrapRootElement"] = ({ element }) => {
  return (
    <AuthProvider>
      <CartProvider>
        <WishlistProvider>
          {element}
          <AuthModal />
        </WishlistProvider>
      </CartProvider>
    </AuthProvider>
  );
};
